export const MapNames = {
    'Neon_Main': 'Rondo_Main_High_Res.webp',
    'Baltic_Main': 'Erangel_Main_High_Res.png',
    'DihorOtok_Main': 'Vikendi_Main_High_Res.png',
    'Range_Main': 'Camp_Jackal_Main_High_Res.png',
    'Desert_Main': 'Miramar_Main_High_Res.png',
    'Tiger_Main': 'Taego_Main_High_Res.png',
    'Savage_Main': 'Sanhok_Main_High_Res.png',
    'Chimera_Main': 'Paramo_Main_High_Res.png',
    'Summerland_Main': 'Karakin_Main_High_Res.png',
    'Kiki_Main': 'Deston_Main_High_Res.png'
};

export const mapTiles = {
    'Neon_Main': 'Rondo_Main_High_Res.webp',
    'Baltic_Main': 'Erangel_Main_High_Res.png',
    'DihorOtok_Main': 'Vikendi_Main_High_Res.png',
    'Range_Main': 'Camp_Jackal_Main_High_Res.png',
    'Desert_Main': 'Miramar_Main_High_Res.png',
    'Tiger_Main': 'Taego_Main_High_Res.png',
    'Savage_Main': 'Sanhok_Main_High_Res.png',
    'Chimera_Main': 'Paramo_Main_High_Res.png',
    'Summerland_Main': 'Karakin_Main_High_Res.png',
    'Kiki_Main': 'Deston_Main_High_Res.png'
};
export const MapSize = {
    'Tiger_Main': 816000,
    'Neon_Main': 816000,
    'Desert_Main': 816000,
    'Kiki_Main': 816000,
    'Range_Main': 204000,
    'Baltic_Main': 819000,
    'Savage_Main': 408000,
    'DihorOtok_Main': 816000,
    'Chimera_Main': 306000,
    'Summerland_Main': 204000
};
